import React, { Component } from "react";
import { withRouterHooks } from "../../../withRouters/withRoutersHook";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FetchCSVAction } from "../../../Actions/Analysis";
import { Files, CheckCircle, XCircle } from "lucide-react";

class FileUploadMetrics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      successful: 0,
      failed: 0,
    };
  }

  static propTypes = {
    FetchCSVAction: PropTypes.func.isRequired,
    csvFileUploadSuccess: PropTypes.bool,
    location: PropTypes.object.isRequired,
  };

  getFileType = () => {
    const { pathname } = this.props.location;
    if (pathname === "/dashboard") return "csv";
    if (pathname === "/dashboard/pdf-analyzer") return "pdf";
    return null;
  };

  fetchMetrics = async () => {
    const response = await this.props.FetchCSVAction(null, this.getFileType());
    if (response) {
      this.setState({
        total: response.count || 0,
        successful: response.successful || 0,
        failed: response.failed || 0,
      });
    }
  };

  componentDidMount() {
    this.fetchMetrics();
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.csvFileUploadSuccess &&
        this.props.csvFileUploadSuccess !== prevProps.csvFileUploadSuccess) ||
      this.props.deleteCount !== prevProps.deleteCount
    ) {
      this.fetchMetrics();
    }
  }

  render() {
    const { total, successful, failed } = this.state;

    return (
      <div className="flex flex-col gap-3">
        <p className="font-inter font-normal text-sm text-gray-500">
          Below are the number of files you have processed
        </p>
        <div className="flex flex-col sm:flex-row w-full gap-3">
          {/* Total */}
          <div className="w-full sm:w-1/3 rounded-xl px-5 py-5 flex flex-col gap-3 border border-blue-100" style={{ background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 100%)" }}>
            <div className="flex items-center justify-between">
              <div className="font-inter text-xs font-medium text-gray-500 uppercase tracking-wider">Total Files Processed</div>
              <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center">
                <Files className="w-4 h-4 text-blue-500" />
              </div>
            </div>
            <div className="font-inter text-4xl font-semibold text-gray-900">{total}</div>
            <div className="text-xs text-gray-400 font-inter border-t border-blue-100 pt-2">All uploaded files</div>
          </div>

          {/* Successful */}
          <div className="w-full sm:w-1/3 rounded-xl px-5 py-5 flex flex-col gap-3 border border-green-100" style={{ background: "linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)" }}>
            <div className="flex items-center justify-between">
              <div className="font-inter text-xs font-medium text-green-600 uppercase tracking-wider">Successful Analysis</div>
              <div className="w-8 h-8 rounded-lg bg-green-50 flex items-center justify-center">
                <CheckCircle className="w-4 h-4 text-green-500" />
              </div>
            </div>
            <div className="font-inter text-4xl font-semibold text-green-600">{successful}</div>
            <div className="text-xs text-gray-400 font-inter border-t border-green-100 pt-2">Successfully processed</div>
          </div>

          {/* Failed */}
          <div className="w-full sm:w-1/3 rounded-xl px-5 py-5 flex flex-col gap-3 border border-red-100" style={{ background: "linear-gradient(135deg, #ffffff 0%, #fff5f5 100%)" }}>
            <div className="flex items-center justify-between">
              <div className="font-inter text-xs font-medium text-red-500 uppercase tracking-wider">Failed Analysis</div>
              <div className="w-8 h-8 rounded-lg bg-red-50 flex items-center justify-center">
                <XCircle className="w-4 h-4 text-red-400" />
              </div>
            </div>
            <div className="font-inter text-4xl font-semibold text-red-500">{failed}</div>
            <div className="text-xs text-gray-400 font-inter border-t border-red-100 pt-2">Errors during processing</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  csvFileUploadSuccess: state.analysis.csvFileUploadSuccess,
  deleteCount: state.analysis.deleteCount,
});

export default withRouterHooks(
  connect(mapStateToProps, { FetchCSVAction })(FileUploadMetrics)
);
